import { loadFont as c } from "../../lib/DynamicKit.js";
import { i as g, x as m } from "../../lit-element-6iugfgmM.js";
import { S as f } from "../../Base-pdJ5fkYW.js";
import { o as p } from "../../style-map-DBc4Yfgo.js";
import { n as s } from "../../property-BWlAHqg_.js";
import { e as y } from "../../custom-element-wk-AooBb.js";
const u = g`@keyframes loaderBounce{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}:host{--loader-color-1: var(--spectrum-global-color-gray-600);--loader-color-2: var(--spectrum-global-color-gray-900);--loader-height-1: var(--spectrum-global-dimension-static-size-100);--loader-height-2: var(--spectrum-global-dimension-static-size-150);--loader-margin-1: var(--spectrum-global-dimension-static-size-25) 0 0 calc(-1 * var(--spectrum-global-dimension-static-size-100));--loader-margin-2: 0 0 0 var(--spectrum-global-dimension-static-size-50);--loader-width-1: var(--spectrum-global-dimension-static-size-100);--loader-width-2: var(--spectrum-global-dimension-static-size-150)}:host([loading]){text-align:center;position:relative;visibility:hidden}:host([loading]):before,:host([loading]):after{animation:loaderBounce 1.5s infinite ease-in-out;animation-fill-mode:both;border-radius:100%;content:\"\";left:50%;position:absolute;top:50%;visibility:visible}:host([loading]):before{background-color:var(--loader-color-1);height:var(--loader-height-1);margin:var(--loader-margin-1);width:var(--loader-width-1)}:host([loading]):after{animation-delay:var(--spectrum-global-animation-duration-500);background-color:var(--loader-color-2);height:var(--loader-height-2);margin:var(--loader-margin-2);width:var(--loader-width-2)}`, b = g`:host(:not([always-display])[failed]){position:relative;visibility:hidden}:host(:not([always-display])[failed]):before{align-items:center;bottom:0;content:\"🚫\";display:flex;justify-content:center;left:0;position:absolute;right:0;top:0;visibility:visible}`;
var v = Object.defineProperty, S = Object.getOwnPropertyDescriptor, o = (t, a, i, n) => {
  for (var l, r = n > 1 ? void 0 : n ? S(a, i) : a, d = t.length - 1; d >= 0; d--) (l = t[d]) && (r = (n ? l(a, i, r) : l(r)) || r);
  return n && r && v(a, i, r), r;
};
const F = "adobe-notdef", h = new IntersectionObserver((t) => {
  t.forEach((a) => {
    var n;
    const i = a.target;
    a.isIntersecting && i.hasAttribute("lazy") && ((n = i.loadFont) == null || n.call(i), h.unobserve(i));
  });
});
let e = class extends f {
  constructor() {
    super(...arguments), this.fontStyle = "", this.fontFeatureSettings = "", this.fontVariationSettings = "", this.fontWeight = "", this.lazy = !1, this.webId = "", this.unicodeRange = "";
  }
  static get styles() {
    return [u, b];
  }
  updated() {
    this.lazy ? h.observe(this) : this.loadFont();
  }
  render() {
    return m`<slot style="${p(this._getFontStyleMap())}"></slot>`;
  }
  loadFont() {
    this._loadedFont || (this.setAttribute("loading", ""), c(this._getCSSFamilyName(), this.webId, { featureSettings: this.fontFeatureSettings, style: this.fontStyle, weight: this.fontWeight, unicodeRange: this.unicodeRange }).then((t) => {
      t && (this._loadedFont = t);
    }).catch(() => {
      this.setAttribute("failed", "failed");
    }).finally(() => {
      this.removeAttribute("loading");
    }));
  }
  _getFontStyleMap() {
    const t = { "font-family": this._getCSSFontFamily(), "font-style": this.fontStyle, "font-weight": this.fontWeight.toString() };
    return this.fontVariationSettings !== "" && (t["font-variation-settings"] = this.fontVariationSettings), t;
  }
  _getCSSFontFamily() {
    return [this._getCSSFamilyName(), F].join(",");
  }
  _getCSSFamilyName() {
    return `${this.webId}-${this.fontStyle}-${this.fontWeight}`;
  }
};
o([s({ type: String })], e.prototype, "fontStyle", 2), o([s({ type: String })], e.prototype, "fontFeatureSettings", 2), o([s({ type: String })], e.prototype, "fontVariationSettings", 2), o([s()], e.prototype, "fontWeight", 2), o([s({ type: Boolean })], e.prototype, "lazy", 2), o([s({ type: String })], e.prototype, "webId", 2), o([s({ type: String })], e.prototype, "unicodeRange", 2), e = o([y("af-display-in-font")], e);
const W = e;
export {
  W as default
};
//# sourceMappingURL=DisplayInFont.js.map
